import React from "react";

import { RIGHTS_RESERVED } from "@/constants/AppConstants";
import styles from "./SimpleFooter.module.css";

// eslint-disable-next-line react/require-default-props
function SimpleFooter({ isDark = false }: { isDark?: boolean }) {
  return (
    <footer className={`${styles.footer} ${isDark ? styles.darkMode : ""}`}>
      <p className={styles.copyrightText}>{RIGHTS_RESERVED}</p>
    </footer>
  );
}

export default SimpleFooter;
